$(document).ready(function () {
  $('.product__variants-swatches .swatches__container').each(function(event) {
    let optionName = $(this).find('input').attr('customdata');
      jQuery(`input[customdata='${optionName}']`).on("click", function (e) {
        // let RadioVal =  $(this).val().toLowerCase().replace(/ /g, "-");
        let RadioVal =  $(this).siblings('label').attr('dataTitle');
        let RadioVal2 =  $(this).siblings('label').attr('dataSizeTitle');
        if (RadioVal) {
        setTimeout(function () {
                $(".product-single__thumbnails-item.carousel-cell").css('display', 'none')
                jQuery(".myclass")
                    .find(".carousel-cell")
                    .each(function () {
                        let imgVal = $(this);
                          let imageData = imgVal.attr("dataimagetitle").toLowerCase().split(" ");
                        $(imageData).each(function (value, index) {
                          if (index ==  RadioVal) {
                            // console.log(RadioVal, 'RadioVal', $(imgVal), '$(imgVal)')
                                $(imgVal).css('display', 'block')
                                $('.carousel-cell').attr('aria-current', "true")
      
                               // $(imgVal).parents('.product__gallery--container').find('#slider .carousel-cell').each(function () {
                               //  let mainImg = $(this).find('img').attr('alt')
                               //   if (mainImg == RadioVal) {
                               //       $(this).css('display', 'block')
                               //       $(this).attr('aria-hidden', 'false')
                               //   }
                               // })
                              }
                          })
                    });
          }, 100);
       }else{
            console.log('----')
       }
    });
  });
});




// else if(RadioVal2){
//           setTimeout(function () {
//                 $(".product-single__thumbnails-item.carousel-cell").css('display', 'none')
//                 jQuery(".myclass")
//                     .find(".carousel-cell")
//                     .each(function () {
//                         let imgVal = $(this);
//                           let imageData = imgVal.attr("dataimagetitle").toLowerCase().split(" ");
//                         $(imageData).each(function (value, index) {
//                           if (index ==  RadioVal2 && index == RadioVal) {
//                                 $(imgVal).css('display', 'block')
//                                 $('.carousel-cell').attr('aria-current', "true")
//                               }
//                           })
//                     });
//           }, 100);
//        }